var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.trackingId)?_c('a',{attrs:{"target":"_blank","href":`/orders/detail?tracking_id=${_vm.trackingId}`}},[_vm._v(" "+_vm._s(_vm.trackingId)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }